/**
 * News selectors
 */

import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectFilters = (state: any) => state.filters || initialState;

const optionsCitiesSelector =
  createSelector(
    selectFilters,
    filtersState => filtersState.optionsCities,
);

const optionsCitySelector =
  createSelector(
    selectFilters,
    filtersState => filtersState.optionsCity,
);

const loadingSelector =
  createSelector(
    selectFilters,
    filtersState => filtersState.loading,
);

const optionsCompaniesSelector =
  createSelector(
    selectFilters,
    filtersState => filtersState.optionsCompanies,
);

const optionsPositionsSelector =
  createSelector(
    selectFilters,
    filtersState => filtersState.optionsPositions,
);


const optionsPositionSelector =
  createSelector(
    selectFilters,
    filtersState => filtersState.optionsPosition,
);

const optionsCompanySelector =
  createSelector(
    selectFilters,
    filtersState => filtersState.optionsCompany,
);

export {
  optionsCitiesSelector,
  loadingSelector,
  optionsCompaniesSelector,
  optionsPositionsSelector,
  optionsCitySelector,
  optionsPositionSelector,
  optionsCompanySelector
 };
